import { render, staticRenderFns } from "./ManualSettings.vue?vue&type=template&id=2ced37b2&scoped=true&lang=html&"
import script from "./ManualSettings.vue?vue&type=script&lang=js&"
export * from "./ManualSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced37b2",
  null
  
)

export default component.exports